import React, { useState, useReducer, useEffect, memo } from "react"
import {
  Table,
  Button,
  Col,
  Divider,
  Input,
  Modal,
  Progress,
  Radio,
  Row,
  Select,
  Form,
  Checkbox,
  Space,
} from "antd"
import { PersianDatePickerInline } from "components/Common/PersianDatePickerInline"
import { enumToArrayAnt } from "helpers/service_helper"
import { EngineerGradeType } from "models/types/eng-grade-type"
import { EngHistoryColumns } from "./eng-history-columns"
const EngHistoryEdit = ({
   mainRowData, 
   rowData, 
   mainProps 
  }) => {

  const [form] = Form.useForm()
  const [open, setOpen] = useState(false)
  const [data, setData] = useState([])
  const [solarCreditDate, setSolarCreditDate] = useState("")
  const [solarWorkPermitDateOfIssue, setSolarWorkPermitDateOfIssue] = useState("")
  const [solarDateIs2p, setSolarDateIs2p] = useState("")
  const [engineerGradeType, setEngineerGradeType] = useState([])
  const [editingId, setEditingId] = useState(null)

  useEffect(() => {
    setEngineerGradeType(enumToArrayAnt(EngineerGradeType))
  }, [])


  const handleSubmit = values => {
    // if (editingId) {
      // Update existing data
      // const updatedData = data.map(item =>
      //   item.Id === editingId ? { ...item, ...values, solarBirthDate } : item
      // )

      let updatedData = {
        ...values,
        solarCreditDate: solarCreditDate.persian,
        solarWorkPermitDateOfIssue: solarWorkPermitDateOfIssue.persian,
        solarDateIs2p: null,
        engId:mainRowData.id,
        id: editingId,
      }
      // delete updatedData.julianCreditDate
      // delete updatedData.julianWorkPermitDateOfIssue
      // delete updatedData.julianDateIs2p
      mainProps.onUpsertEngHistory(updatedData)

      // setData(updatedData)

      setEditingId(null)
    // } else {
    //   // Insert new data
    //   const newData = { ...values }
    //   setData([...data, newData])
    // }
    form.resetFields()
  }
  // Function to handle edit button click
  const handleEdit = record => {
    form.setFieldsValue(record)
    // setSolarBirthDate(record.solarBirthDate)
    setEditingId(record.id)
  }
  return (
    <>
      <Button  onClick={() => setOpen(true)}>
       پروانه
      </Button>

      <Modal
        title={"ویرایش پروانه کارشناس:" + mainRowData.fullName}
        centered
        open={open}
        onCancel={() => setOpen(false)}
        width={1000}
        footer={null}
      >
          <Form name="engHistoryForm" form={form} onFinish={handleSubmit}>
          <Row gutter={[8, 8]}>
          <Col>
              <Form.Item
                required
                label="تاریخ اخذ پروانه:"
                name="julianWorkPermitDateOfIssue"
              >
                <PersianDatePickerInline
                  defaultDate={form
                    .getFieldValue("julianWorkPermitDateOfIssue")
                    ?.toString()
                    ?.substring(0, 10)}
                  setPersianDate={setSolarWorkPermitDateOfIssue}
                />
              </Form.Item>
            </Col>
            <Col>
              <Form.Item
                required
                label="تاریخ اعتبار پروانه:"
                name="julianCreditDate"
              >
                <PersianDatePickerInline
                  defaultDate={form
                    .getFieldValue("julianCreditDate")
                    ?.toString()
                    ?.substring(0, 10)}
                  setPersianDate={setSolarCreditDate}
                />
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={[8, 8]}>
            <Col>
              <Form.Item
                required
                label="اجازه کار"
                name="workPermission"
                valuePropName="checked"
              >
                <Checkbox />
              </Form.Item>
            </Col>
            <Col>
              <Form.Item
                required
                label="پایه"
                name="engineerGradeTypeEnum"
                initialValue={form.getFieldValue("engineerGradeTypeEnum")}
              >
                <Select
                  style={{ width: 200 }}
                  name="engineerGradeTypeEnum"
                  options={engineerGradeType}
                />
              </Form.Item>
            </Col>
            <Col>
              <Form.Item
                required
                label="شماره پروانه"
                name="workPermitNum"
              >
                <Input/>
              </Form.Item>
            </Col>
            {/* <Col>
              <Form.Item
                required
                label="صلاحیت صنعتی"
                name="is2p"
                initialValue={false}
                valuePropName="checked"
              >
                <Checkbox />
              </Form.Item>
            </Col> */}
          </Row>

          <Divider></Divider>
          <Row>
            <Col>
              {mainProps.loading ? (
                <Progress type="circle" />
              ) : (
                <Button type="primary" htmlType="submit">
                  ذخیره
                </Button>
              )}
              <Button htmlType="button" onClick={() => form.resetFields()}>
                ریست فرم
              </Button>
            </Col>
          </Row>

          <Table
            loading={mainProps.loading}
            size="small"
            pagination={true}
            scroll={{
              y: 670,
              x: 700,
            }}
            sticky
            columns={EngHistoryColumns({
              mainProps,
              handleEdit,
            })}
            rowClassName={(_r, i) => (i % 2 ? "odd" : "even")}
            rowKey={record => record.id}
            dataSource={[...rowData]}
          />
        </Form>
      </Modal>
    </>
  )
}
export default EngHistoryEdit
